// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"_3Nzq-X_JN2MXp6iLDnNky6"};